import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FundList from "@/pages/FundList";
import FundDetail from "@/pages/FundDetail";
import Compare from "@/pages/Compare";
import AmcScorecard from "@/pages/AmcScorecard";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import Enquiries from "@/pages/Enquiries";
import BlogsList from "@/pages/BlogsList";
import BlogDetail from "@/pages/BlogDetail";
import AdminAddBlog from "@/pages/AdminAddBlog";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App flex flex-col min-h-screen justify-between">
      <BrowserRouter>
        <ScrollToTop />
        <div>
          <Header />
          <Routes>
            <Route path="/" element={<FundList />} />
            <Route path="/fund/:code" element={<FundDetail />} />
            <Route path="/compare" element={<Compare />} />
            <Route path="/amcs" element={<AmcScorecard />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/enquires" element={<Enquiries />} />
            <Route path="/enquiries" element={<Enquiries />} />
            <Route path="/blogs" element={<BlogsList />} />
            <Route path="/blogs/:slug" element={<BlogDetail />} />
            <Route path="/admin/add-blog" element={<AdminAddBlog />} />
          </Routes>
        </div>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;

